<template>
  <div id="app">
    <div class="input-box">
      <textarea class="textarea" v-model="inputText" :placeholder="'请输入' + title" maxlength="500"></textarea>
    </div>
    <div class="btn-box">
      <div class="btn" @click="onSave">保存</div>
    </div>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
export default {
  name: 'App',
  data() {
    return {
      title: '',
      inputText: '111'
    }
  },
  created() {

  },
  mounted() {
    const title = this.getUrlParam('title');
    document.title = title;
    this.title = title;
    const text = this.getUrlParam('text');/// this.inputText = this.getUrlParam('text');
    this.inputText = text ? text.replace(/\\n/g, '\n') : '';
  },
  methods: {
    onSave() {
      wx.miniProgram.postMessage({
        data: {
          text: this.inputText
        }
      });
      wx.miniProgram.navigateBack()
    },
    getUrlParam(name) {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(name);
    }
  }
}
</script>

<style>
  html, body{
    margin: 0;
    padding: 0;
  }
  .textarea{
    border: 1px solid #e5e5e5;
    background: #f5f6fa;
    margin: 1.25rem;
    flex: 1;
    font-size: 0.875rem;
    line-height: 1.25rem;
    padding: 0.625rem;
    height: 20rem;
  }
  .input-box{
    display: flex;
  }
  .btn-box{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 1.25rem 1.25rem 1.25rem;
  }
  .btn{
    height: 2.75rem;
    line-height: 2.75rem;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #224e8f;
    border-radius: 4px;
    font-size: 0.875rem;
    color: #fff;
    width: 100%;
  }
</style>
